(ns common.flags
  (:require ["launchdarkly-react-client-sdk" :refer [useFlags useLDClient]]
            [camel-snake-kebab.core :refer [->kebab-case]]
            [camel-snake-kebab.extras :refer [transform-keys]]
            [cljs-bean.core :refer [->clj ->js]]
            [common.db.coeffects.localstorage]
            [common.db.effects.localstorage]
            [common.queries :refer [use-query]]
            [common.resource.query.adset :as adset.q]
            [common.resource.query.advertiser :as advertiser.q]
            [common.resource.query.agency :as agency.q]
            [common.resource.query.campaign :as campaign.q]
            [common.resource.query.user :refer [user-query]]
            [common.util :as util :refer [spread-obj]]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [defhook]]
            [uix.re-frame :refer [use-subscribe]]))

(rf/reg-event-db :flag/sync-flags
  (fn [db [_ flags]]
    (assoc db ::flags flags)))

(rf/reg-sub ::flags
  (fn [db]
    (::flags db)))

(rf/reg-sub :flag/enabled
  :<- [::flags]
  (fn [flags [_ flag]]
    (get flags flag)))

(defhook use-flag [flag]
  (let [flags (->> (useFlags) ->clj (transform-keys ->kebab-case))]
    (get flags flag)))

(defhook use-flags [flags]
  (let [all-flags (->> (useFlags) ->clj (transform-keys ->kebab-case))]
    (into {} (filter #(some? ((key %) flags)) all-flags))))

(defhook use-identify-context []
  (let [ld-client (useLDClient)
        {user :data} (use-query (user-query))
        url-context (use-subscribe [:url-context])

        {agency :data} (use-query (agency.q/agency-query url-context))
        {advertiser :data} (use-query (advertiser.q/advertiser-query url-context))
        {campaign :data} (use-query (campaign.q/campaign-query url-context))
        {adset :data} (use-query (adset.q/adset-query url-context))

        context (uix/use-memo
                 (fn []
                   (spread-obj #js {:kind "multi"
                                    :user #js {:kind "user"
                                               :key (:id user)}}

                               (when agency
                                 #js {:agency #js {:kind "agency"
                                                   :key (:id agency)
                                                   :name (:name agency)}})
                               (when advertiser
                                 #js {:advertiser (spread-obj
                                                   #js {:kind "advertiser"
                                                        :key (:id advertiser)}
                                                   (->js advertiser))})
                               (when campaign
                                 #js {:campaign (spread-obj #js {:kind "campaign"
                                                                 :key (:id campaign)}
                                                            (-> campaign
                                                                (select-keys [:name :active :archived])
                                                                ->js))})
                               (when adset
                                 #js {:adset (spread-obj #js {:kind "adset"
                                                              :key (:id adset)}
                                                         (-> adset
                                                             (select-keys [:archived :plannedStart :plannedEnd :targetImpressions
                                                                           :updatedAt :feedId :name :createdAt :channel :PSCampaignIds
                                                                           :videoUsed :countries :workflow :autoApproveAdVariants :id
                                                                           :contentType :targetType :legacy :blocked])
                                                             ->js))})))
                 [user agency advertiser campaign adset])

        flags (->> (useFlags) ->clj (transform-keys ->kebab-case))]
    (uix/use-effect
     (fn []
       (when (and user url-context)
         (.identify ld-client context)))
     [ld-client user url-context context])

    (uix/use-effect
     (fn []
       (rf/dispatch [:flag/sync-flags flags]))
     [flags])))
